import {Attribute, Directive, ElementRef, Inject, OnInit, Self} from '@angular/core';
import {register} from '@wm/components-base';
import {FormComponent} from "./form.component";
import {runtimeEventManager} from "@wm/core"
import {FormFieldDirective} from "./form-field/form-field.directive";


@Directive({
  selector: '[wmLiveFilter]',
  standalone: true
})
export class LiveFilterDirective  implements OnInit{
  static initializeProps = register('wm-livefilter');
  variableService: any;
  variableType: string;
  variableName: any;
  formFields: { [key: string]: any } = {};
  isliveFilter: boolean = true
  formfields: { [key: string]: FormFieldDirective } = {};
  formWidgets: { [key: string]: FormFieldDirective } = {};

  constructor(@Self() @Inject(FormComponent) private form: FormComponent,
              @Inject(ElementRef) public _el: any, @Attribute('datasource.bind') public binddatasource: any,) {
    this.form.isLivefilter = this.isliveFilter;
    this.variableService = runtimeEventManager.getService('variableService');

  }
  ngOnInit() {
      let variableName = this.binddatasource?.split('Variables.')[1];
      let variable = this.variableService.getVariableByName(variableName);
      this.form.variableType = variable?.category;
  }


}
